import { languageService } from "../../../Language/language.service";

export const materialTypeSection = () => ({
  tenantId: "ps19",
  listName: "materialTypesSchema",
  code: "materialTypeSectionCode",
  description: "Material Type Sections",
  opt1: {
    schema: [
      {
        id: "Item No",
        type: "input",
        labelValue: languageService("Item No."),
        disabledStates: ["edit"],
        required: true,
      },
      {
        id: "desc",
        labelValue: languageService("Description"),
        type: "input",
        required: true,
      },

      {
        id: "UM",
        type: "select",
        labelValue: languageService("Unit"),
        selectOptions: [
          { val: "", text: "Select" },
          { val: "EA", text: "EA" },
          { val: "Each", text: "Each" },
          { val: "FT", text: "FT" },
          { val: "Z", text: "Z" },
          { val: "GA", text: "GA" },
          { val: "PR", text: "PR" },
          { val: "NT", text: "NT" },
        ],
        required: true,
      },
    ],
  },
});



// WEBPACK FOOTER //
// ./src/components/MaterialTypeListView/materialTypeSection/materialTypeSections.js